//#Global Imports
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import moment from "moment";
//#end Global Imports

//#Local Imports
import ErrorField from "../../../../components/ui/ErrorField";
import TextField from "../../../../components/ui/TextField";
import Typograpy from "../../../../components/ui/Typography";
import Button from "../../../../components/ui/Button";
import { PassportIcon, ReloadIcon, UploadIcon, WarningIcon } from "../../../../assets/Icons";
import IUserDocuments from "../../userDocuments";
import { DatePicker } from "../../../../components/ui/DatePicker";
import { useRecoilValue } from "recoil";
import { panDeclaration } from "../../../../store";
//#end Local Imports

const PanCardSection: React.FC<IUserDocuments.IPanCardSectionProps> = ({
  panCardDetails,
  handleDeleteDoc,
  handleChangeUpload,
  handleEVerifyPanCard,
  setPanCardDetails,
  handlePanDobChangeHandler,
  docDob,
  buttonLoader,
  aadhaarLinked,
}) => {
  const panDeclarationValue = useRecoilValue(panDeclaration);
  const [panMismatchError, setPanMismatchError] = useState<boolean>(false);
  const convertedDate = moment(docDob, "DD/MM/YYYY").toDate();
  const maxDate = moment(new Date()).format("YYYY-MM-DD").toString();

  useEffect(() => {
    if (panDeclarationValue !== "" && panCardDetails?.panNumber !== "") {
      if (panDeclarationValue !== panCardDetails?.panNumber) {
        setPanMismatchError(true);
      } else {
        setPanMismatchError(false);
      }
    } else {
      setPanMismatchError(false);
    }
  }, [panCardDetails]);

  return (
    <div className="col-span-4 lg:pl-10 lg:pt-7">
      <div>
        <Typograpy
          tagType="div"
          className="mb-5 text-base font-medium text-black"
          text="Upload PAN"
        />
        <div className="relative">
          <div className="flex items-center space-x-8 ">
            <Button
              bgColor="bg-transparent"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor: `${
                  panCardDetails.isPanVerified || panCardDetails.isPanUploaded
                    ? "border-success-150"
                    : "border-grey-150"
                }`,
                borderRadius: "rounded",
              }}
              className="w-full lg:w-[48%] mb-5 h-[68px]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      panCardDetails.isPanVerified || panCardDetails.isPanUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload PAN Front</div>
                </div>
                <div className="flex items-center space-x-2">
                  {!panCardDetails.isPanVerified &&
                    (panCardDetails.isPanUploaded ? (
                      <div
                        onClick={
                          panCardDetails.isPanUploaded && !panCardDetails.isPanVerified
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor={"fill-secondary-600"} width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor={"fill-secondary-600"} />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          {panCardDetails.uploadedDocError !== "" && (
            <ErrorField errorMessage={panCardDetails.uploadedDocError} />
          )}
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="PAN_CARD"
              type="file"
              disabled={panCardDetails.isPanUploaded}
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              onChange={(e) => handleChangeUpload(e, "PAN_CARD")}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="flex flex-col items-start w-full space-x-8 lg:items-start lg:flex-row">
          <div className="w-full">
            <Typograpy
              tagType="div"
              className="mb-5 text-base font-medium text-black"
              text="PAN Card No"
            />
             <TextField
              name="panNo"
              type="text"
              inputClasses={clsx(
                panCardDetails.isPanVerified ? "border-success-150" : "border-grey-150",
                "border  !pt-1 lg:!w-full",
              )}
              value={panCardDetails?.panNumber}
              onChange={(event) =>
                setPanCardDetails((preValue: any) => {
                  return {
                    ...preValue,
                    panNumber: event.target.value,
                  };
                })
              }
              error={panCardDetails.messagePan !== ""}
              disabled={!panCardDetails?.isPanUploaded}
              fullWidth
              pattern="[a-zA-Z0-9 ]{1,}"
            />
            <div
              className={clsx(
                panCardDetails.messagePan !== ""
                  ? "text-error"
                  : panCardDetails.messagePanVerified !== ""
                  ? "text-success"
                  : "",
                " font-ssp font-medium text-sm mt-1",
              )}
            >
              {panCardDetails.messagePan === ""
                ? panCardDetails.messagePanVerified
                : panCardDetails.messagePan}
            </div>
          </div>
          <div className="w-full">
            <div className="mb-5 text-base font-medium text-black font-lato">DOB as per PAN</div>
            <DatePicker
              selectedDate={
                docDob === "" ? new Date().toString() : moment(convertedDate).format("YYYY-MM-DD")
              }
              dateChangeHandler={handlePanDobChangeHandler}
              datepickerClassname="bg-transparent !p-4 !rounded border !border-grey-150 lg:w-[300px]"
              disabled={!panCardDetails?.isPanUploaded || panCardDetails?.isPanVerified}
              maxDate={maxDate}
            />
          </div>
        </div>

        {!panCardDetails.isPanVerified && (
          <Button
            bgColor={clsx(
              panCardDetails.isPanUploaded && !panMismatchError ? "bg-primary" : "bg-grey-350",
            )}
            fontStyle={{
              fontFamily: "",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            className={"py-3 lg:py-5 w-full lg:!w-[48%] mt-9 pan-card-verify"}
            disabled={!panCardDetails.isPanUploaded || panMismatchError}
            onClickHandler={handleEVerifyPanCard}
            isLoading={buttonLoader.eVerifyPanCard}
          >
            Verify
          </Button>
        )}
        {panMismatchError && (
          <span className="text-[12px] text-red-100">
            Please upload the valid PAN card with the number {panDeclarationValue} or unselect the
            PAN number entered on the send money screen.{" "}
          </span>
        )}
      </div>
      {!aadhaarLinked && (
        <div className="bg-[#FFFAE6] p-4 flex items-start mt-[10%]">
          <div className="text-yellow-400 mr-4 mt-1">
            <WarningIcon />
          </div>

          <div>
            <h3 className="font-bold text-black">PAN and Aadhar not linked</h3>
            <p className="text-black mt-3">
              You can initiate your transaction, but it will be put on hold. We will wait for 3
              working days for you to get this linked, post that the transaction will get cancelled
              and the amount will be refunded.&nbsp;
              <a
                href="https://www.moneyhop.co/blog/all-you-need-to-know-about-pan-aadhar-linking"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#156BFF", textDecoration: "none", cursor: "pointer" }}
              >
                Know more
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PanCardSection;
